import Toast from '../Toast';
import { IToastContainerProps } from './ToastContainer.types';

const ToastsContainer = ({
  toasts,
}: IToastContainerProps): JSX.Element | null => {
  return (
    <div className="toasts-container">
      {toasts.map(toast => (
        <Toast key={toast.id} {...toast} />
      ))}
    </div>
  );
};

export default ToastsContainer;
